import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { primarycolor } from "../Utils/colors";
import styles from "./../Hostels/houses.module.css";

const Houseimages = ({ imagesarray }) => {

    return (
        <Swiper
            slidesPerView={1}
            spaceBetween={0}
            slidesPerGroup={1}
            loop={true}
            loopFillGroupWithBlank={true}
            autoplay={{
                delay: 3000,
                disableOnInteraction: false,
            }}
            speed={2000}
            shortSwipes={false}
            modules={[Autoplay, Pagination, Navigation]}
            color={primarycolor}
            navigation={true}
            style={{
                "--swiper-pagination-color": "#000",
                "--swiper-navigation-color": "#000",
                "--swiper-navigation-size": "20px"
            }}
        >
            {Array.isArray(imagesarray) && imagesarray.map((val, key) => {

                return (
                    <SwiperSlide key={key} >
                        <img src={val} className={styles.mainphoto} />
                    </SwiperSlide>
                )
            })

            }
        </Swiper>
    )
}

export default Houseimages;